export default "__VITE_ASSET__DhbxfJLl__"